module.exports = __webpack_public_path__ + "static/media/run_user.caa44e5f.jpg";